import { defineAsyncComponent } from 'vue'

const BusModuleRouteFormModal = defineAsyncComponent(
  () => import('./bus-module-route-form-modal.vue'),
)
const BusModuleRouteModal = defineAsyncComponent(() => import('./bus-module-route-modal.vue'))

const BusModuleRoutesTable = defineAsyncComponent(() => import('./bus-module-routes-table.vue'))
const BusModuleRoute = defineAsyncComponent(() => import('./bus-module-route.vue'))
const BusModuleRoutesSelect = defineAsyncComponent(() => import('./bus-module-routes-select.vue'))

export {
  BusModuleRoute,
  BusModuleRouteFormModal,
  BusModuleRouteModal,
  BusModuleRoutesSelect,
  BusModuleRoutesTable,
}
